const HOURS: string[] = []
for (let i = 0; i < 24; i++) {
  const hourToAdd = i >= 10 ? i : '0' + i
  HOURS.push(hourToAdd + ':00')
  HOURS.push(hourToAdd + ':30')
}

export { HOURS }
export const MORNING_HOURS = HOURS.slice(0, HOURS.length - 1)
export const EVENING_HOURS = HOURS.slice(1)

export enum NOTIFICATION_HOURS_DEFAULTS {
  MORNING = '08:00',
  EVENING = '16:00',
}

const HOURS_SPLIT_BY_5_MINUTES: string[] = []
for (let i = 0; i < 24; i++) {
  const hourToAdd = i >= 10 ? i : '0' + i
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':00')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':05')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':10')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':15')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':20')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':25')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':30')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':35')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':40')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':45')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':50')
  HOURS_SPLIT_BY_5_MINUTES.push(hourToAdd + ':55')
}
export { HOURS_SPLIT_BY_5_MINUTES }
